export default {
  sections: {
    address: 'Adresă',
    legal_address: 'Adresă de înregistrare',
    invoice_address: 'Adresă de facturare',
  },
  form: {
    display_name: {
      label: 'Nume prietenos',
      placeholder: 'Introduceți numele prietenos al companiei',
    },
    legal_name: {
      label: 'Nume legal',
      placeholder: 'Introduceți numele legal',
      tooltip: 'Numele de înregistrare. Afișat pe rapoartele de plată, contract etc.',
    },
    timezone: {
      label: 'Fus orar',
    },
    has_dedicated_invoice_address: {
      label: 'Date de facturare diferite',
    },
  },
  buttons: {
    next: 'Înainte',
  },
};
